import { createSlice } from "@reduxjs/toolkit";

const initialTypeState = { typeIs: null};

const typeSlice = createSlice({
    name: 'type',
    initialState: initialTypeState,
    reducers: {
        Plan(state){
            state.typeIs = 'plan';
        },
        News(state){
            state.typeIs = 'news';
        },
        None(state){
            state.typeIs = null;
        }
    }
});

export const typeActions = typeSlice.actions;

export default typeSlice.reducer;